<template>
  <div>
    <DataTable
      v-if="trainings.length"
      striped-rows
      paginator
      :rows="selectedPerPage"
      :value="trainings"
      :table-style="isMobile ? 'width: 100%' : 'min-width: 50rem'"
      selection-mode="single"
      @row-click="$emit('selectTraining', $event.data.id)"
    >
      <template #header>
        <div class="w-100">
          <TableHeader
            v-model="selectedPerPage"
            :total-pages="Math.ceil(trainings.length / selectedPerPage)"
            :target-length="trainings.length"
            :current-page="currentPage"
          />
        </div>
      </template>
      <Column
        v-if="!isAbcTManager"
        :field="(t) => t.watched"
        header="視聴"
        style="width: 40px; max-width: 40px"
      >
        <template #body="{ data }">
          <div class="d-flex justify-content-center align-items-center">
            <i
              v-if="data.watched"
              class="pi pi-check"
              style="color: var(--green-500)"
            ></i>
          </div>
        </template>
      </Column>
      <Column sortable field="title" header="名前" />
      <Column
        sortable
        field="published"
        header="公開日時"
        style="width: 180px; max-width: 180px"
      >
        <template #body="{ data }">
          <span>{{ basicFormatter(data.publishedAt, "slashStyle") }}</span>
        </template>
      </Column>
      <Column
        v-if="!isMobile"
        sortable
        field="unpublished"
        header="公開終了日"
        style="width: 180px; max-width: 180px"
      >
        <template #body="{ data }">
          <span>{{ basicFormatter(data.unpublishedAt, "slashStyle") }}</span>
        </template>
      </Column>
      <template v-if="isAbcTManager">
        <Column
          header="編集"
          :style="{
            width: '60px',
          }"
        >
          <template #body="{ data }">
            <BasicButton
              icon="pi pi-pencil"
              text
              @click="$emit('editTraining', data.id)"
            />
          </template>
        </Column>

        <Column
          header="削除"
          :style="{
            width: '60px',
          }"
        >
          <template #body="{ data }">
            <div v-if="!data.title.includes('会則')">
              <BasicButton
                variant="danger"
                icon="pi pi-trash"
                text
                @click="$emit('destroyTraining', data.id)"
              />
            </div>
          </template>
        </Column>
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { basicFormatter } from "/@/modules/luxon";
import { useMqUtils, useTableHeader } from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { Header as TableHeader } from "/@/vue/components/Molecules/TableUtils";
import { Training, TrainingClient } from "/@/types";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

defineProps<{
  trainings: TrainingClient[];
  isAbcTManager?: boolean;
}>();

defineEmits<{
  (e: "selectTraining", id: number): void;
  (e: "editTraining", id: number): void;
  (e: "destroyTraining", id: number): void;
}>();

//

const { isMobile } = useMqUtils();
const { selectedPerPage, currentPage, changePage } = useTableHeader();
</script>

<style scoped></style>
